/**
 * Navigation state passed via `navigate("/dms/...", { state: ... })` to seed
 * initial row focus on the document list. Read with
 * `useLocation().state as DocumentListFocusState | null`.
 *
 * Primary use case: returning from `DocumentFormPage` to the list - the form's
 * close/back action navigates to the list with `{ focusId: singleId }` so the
 * user lands with the doc they were editing highlighted.
 */
export type DocumentListFocusState = {
    focusId?: string;
};
